import { ServerConnection } from '@paragon/data-connections';

export const DesignService = new ServerConnection('designServiceApiUrl');
